(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/ui/form/assets/javascripts/components/checkbox.trinidad.js') >= 0) return;  svs.modules.push('/components/ui/form/assets/javascripts/components/checkbox.trinidad.js');
"use strict";

(() => {
  "use strict";

  var __webpack_require__ = {};
  (() => {
__webpack_require__.n = module => {
var getter = module && module.__esModule ? () => module['default'] : () => module;
      __webpack_require__.d(getter, {
        a: getter
      });
      return getter;
    };
  })();
  (() => {
__webpack_require__.d = (exports, definition) => {
for (var key in definition) {
if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
Object.defineProperty(exports, key, {
            enumerable: true,
            get: definition[key]
          });
        }
      }
    };
  })();
  (() => {
__webpack_require__.o = (obj, prop) => Object.prototype.hasOwnProperty.call(obj, prop);
  })();
  var __webpack_exports__ = {};

  __webpack_require__.d(__webpack_exports__, {
    "default": () => ( components_checkbox)
  });
  ; 
  const external_PropTypes_namespaceObject = window["PropTypes"];
  var external_PropTypes_default = __webpack_require__.n(external_PropTypes_namespaceObject);
  ; 
  const external_svs_ui_ReactForm_namespaceObject = window["svs"]["ui"]["ReactForm"];
  ; 
  function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function (target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];
        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }
      return target;
    };
    return _extends.apply(this, arguments);
  }

  const Checkbox = _ref => {
    let {
      name = "checkbox-".concat(Math.random(), "[]"),
      value,
      id = "checkbox_".concat(name, "_").concat(value !== null && value !== void 0 ? value : Math.random()),
      labelProps,
      data,
      branding,
      classes,
      className,
      defaultChecked,
      inline,
      minWidth,
      checked,
      disabled,
      onChange,
      children,
      noLabel = false
    } = _ref;
    const dataAttributes = {};
    if (data) {
      data.forEach(data => {
        dataAttributes["data-".concat(data.key)] = data.value;
      });
    }
    const inputClasses = ['form-toggle-input', 'form-toggle-checkbox'];
    if (branding) {
      inputClasses.push("form-toggle-".concat(branding));
    } else {
      inputClasses.push('form-toggle-default');
    }
    if (classes) {
      inputClasses.push(classes);
    }
    if (className) {
      inputClasses.push(className);
    }
    return React.createElement("div", _extends({
      className: "form-toggle ".concat(inline ? 'form-toggle-inline' : '')
    }, minWidth ? {
      style: {
        minWidth
      }
    } : {}), React.createElement("input", _extends({
      checked: checked,
      className: inputClasses.join(' '),
      defaultChecked: defaultChecked,
      disabled: disabled,
      id: id,
      name: name,
      onChange: onChange,
      type: "checkbox",
      value: value
    }, dataAttributes)), !noLabel && React.createElement(external_svs_ui_ReactForm_namespaceObject.Label, _extends({}, labelProps, {
      id: id,
      isButton: true
    }), children));
  };
const components_checkbox = Checkbox;
  (((window.svs = window.svs || {}).ui = window.svs.ui || {}).ReactForm = window.svs.ui.ReactForm || {}).Checkbox = __webpack_exports__["default"];
})();

 })(window);